{
  "accordion": {
    "blurb": "A vertically stacked set of interactive headings that each reveal a section of content.",
    "contentOne": "Yes. It adheres to the WAI-ARIA design pattern.",
    "contentThree": "Yes. It's animated by default, but you can disable it if you prefer.",
    "contentTwo": "Yes. It comes with a default style that matches the other components' aesthetic.",
    "name": "Accordion",
    "triggerOne": "Is it accessible?",
    "triggerThree": "Is it animated?",
    "triggerTwo": "Is it styled?"
  },
  "alert": {
    "actionCta": "Undo",
    "actionTitle": "The selected emails have been marked as spam.",
    "blurb": "A notification to capture user attention.",
    "errorDescription": "Please verify your billing information and try again.<ul><li>Check your card details</li><li>Verify billing address</li></ul>",
    "errorDescriptionNative": "Please verify your billing information and try again.",
    "errorTitle": "Unable to process your payment.",
    "extendedDescription": "This is an equally long description that contains detailed information about the alert. It shows how the component can accommodate extensive content while preserving proper spacing, alignment, and readability across different screen sizes and viewport widths. This helps ensure the user experience remains consistent regardless of the content length.",
    "extendedTitle": "This is an extremely long alert title that spans multiple lines to demonstrate how the component handles very lengthy headings while maintaining readability and proper text wrapping behavior",
    "name": "Alert",
    "noDescTitle": "This Alert has no description.",
    "successDescription": "This is an alert with icon, title and description.",
    "successTitle": "Success! Your changes have been saved"
  },
  "alertDialog": {
    "blurb": "A modal dialog that interrupts the user with important content and expects a response.",
    "description": "This action cannot be undone. This will permanently delete your account and remove your data from our servers.",
    "name": "Alert Dialog",
    "title": "Are you absolutely sure?",
    "trigger": "Show dialog"
  },
  "avatar": {
    "blurb": "An image component featuring an alternative representation for depicting the user.",
    "name": "Avatar"
  },
  "badge": {
    "blurb": "A small count or labeling component that can be used to highlight new or unread items.",
    "default": "Default",
    "destructive": "Destructive",
    "name": "Badge",
    "outline": "Outline",
    "secondary": "Secondary"
  },
  "blocks": {
    "title": "Blocks"
  },
  "breadcrumbs": {
    "title": "Breadcrumb"
  },
  "button": {
    "blurb": "A clickable element that performs an action when pressed.",
    "default": "Default",
    "destructive": "Destructive",
    "disabled": "Disabled",
    "ghost": "Ghost",
    "large": "Large",
    "learnMore": "Learn more",
    "link": "Link",
    "loading": "Loading...",
    "name": "Button",
    "outline": "Outline",
    "secondary": "Secondary",
    "send": "Send",
    "small": "Small"
  },
  "card": {
    "image": {
      "description": "This is a card with an image.",
      "title": "Image card"
    },
    "login": {
      "cta": "Login",
      "ctaGoogle": "Login with Google",
      "description": "Enter your email below to login to your account",
      "emailLabel": "Email",
      "emailPlaceholder": "me@example.com",
      "forgotPassword": "Forgot your password?",
      "noAccount": "Don't have an account? <a>Sign up</a>",
      "passwordLabel": "Password",
      "title": "Login to your account"
    },
    "meetingNotes": {
      "description": "Transcript from the meeting with the client.",
      "title": "Meeting notes"
    },
    "meta": {
      "content": "Content",
      "contentOnly": "Content only",
      "footer": "Footer",
      "footerOnly": "Footer only",
      "headerAndContentDescription": "This is a card with a header and content.",
      "headerAndContentTitle": "Header and content",
      "headerAndFooterDescription": "This is a card with a header and a footer.",
      "headerAndFooterTitle": "Header and footer",
      "headerContentAndFooterDescription": "This is a card with a header, content and a footer.",
      "headerContentAndFooterTitle": "Header, content, and footer",
      "headerOnlyDescription": "This is a card with a header and a description.",
      "headerOnlyTitle": "Header only"
    }
  },
  "checkbox": {
    "multi": {
      "description": "Select how you would like to receive notifications",
      "email": "Email",
      "label": "Notification preferences",
      "push": "Push notifications",
      "sms": "SMS"
    },
    "privacy": "I accept the privacy policy",
    "terms": "I accept the terms and conditions"
  },
  "collapsible": {
    "blurb": "A dynamic element that facilitates the expansion or collapse of a panel.",
    "name": "Collapsible"
  },
  "components": {
    "errorMessage": "Something went wrong in component: {{name}}",
    "name": "Components",
    "title": "Components"
  },
  "datePicker": {
    "placeholder": "Select a date",
    "required": "Must select a date"
  },
  "dialog": {
    "form": {
      "description": "Make changes to your profile here. Click save when you're done.",
      "nameLabel": "Name",
      "title": "Edit your profile",
      "trigger": "Edit profile",
      "usernameLabel": "Username"
    },
    "scrollableContent": {
      "description": "This is a dialog with scrollable content.",
      "title": "Scrollable content",
      "trigger": "Scrollable content"
    },
    "stickyFooter": {
      "description": "This is a dialog with scrollable content and a sticky footer.",
      "title": "Sticky footer",
      "trigger": "Sticky footer"
    }
  },
  "dropdownMenu": {
    "account": "Account",
    "billing": "Billing",
    "blurb": "Displays a menu to the user — such as a set of actions or functions — triggered by a button.",
    "name": "Dropdown Menu",
    "notifications": "Notifications",
    "upgrade": "Upgrade to Pro"
  },
  "form": {
    "bioDescription": "You can @mention other users and organizations.",
    "bioLabel": "Bio",
    "bioPlaceholder": "Tell us about yourself",
    "blurb": "A demo of all the input components included in this template.",
    "emailDescription": "This is the email address that will be displayed on your profile.",
    "emailLabel": "Display email",
    "emailPlaceholder": "Select an email",
    "name": "Form",
    "nextSubscriptionDateLabel": "Next subscription date",
    "nextSubscriptionDatePlaceholder": "Select a date",
    "nextSubscriptionTimeLabel": "Next subscription time",
    "nextSubscriptionTimePlaceholder": "Select a time",
    "notificationsChannelLabel": "Channel preferences",
    "notificationsSubtitle": "Notifications",
    "notificationsTypeLabel": "Notifiy me about...",
    "otpBlurb": "Enter the 6-digit code sent to <medium>{{phoneNumber}}</medium>",
    "otpDescription": "A demo of a form with OTP input for authentication.",
    "otpLabel": "OTP Verification",
    "otpTitle": "OTP Form",
    "subscriptionSubtitle": "Subscription",
    "title": "Form",
    "usernameDescription": "This is your public display name.",
    "usernameLabel": "Username",
    "usernamePlaceholder": "Enter your username",
    "validation": {
      "bioTooLong": "Bio must be at most 140 characters long",
      "bioTooShort": "Bio must be at least 10 characters long",
      "usernameTooShort": "Username must be at least 3 characters long"
    }
  },
  "hoverCard": {
    "description": "This is a hover card. It can contain any content you like, such as text, images, or even other components.\n\nHover cards are great for providing additional information without cluttering the UI. They can be used to display tooltips, additional details, or even actions related to the item being hovered over.",
    "title": "Hover Card",
    "trigger": "Hover over me"
  },
  "input": {
    "default": "Default",
    "disabled": "Disabled",
    "error": "With error",
    "file": "File",
    "number": "Number",
    "password": "Password",
    "phoneNumber": "Phone number",
    "required": "Required",
    "required_label": "You must input this field",

    "search": "Search"
  },
  "label": {
    "disabled": "Disabled",
    "username": "Username"
  },
  "menubar": {
    "edit": "Edit",
    "editMenu": {
      "copy": "Copy",
      "cut": "Cut",
      "find": "Find",
      "findOptions": {
        "find": "Find...",
        "findNext": "Find Next",
        "findPrevious": "Find Previous",
        "searchWeb": "Search the web"
      },
      "paste": "Paste",
      "redo": "Redo",
      "undo": "Undo"
    },
    "file": "File",
    "fileMenu": {
      "newIncognitoWindow": "New Incognito Window",
      "newTab": "New Tab",
      "newWindow": "New Window",
      "print": "Print...",
      "share": "Share",
      "shareOptions": {
        "emailLink": "Email link",
        "messages": "Messages",
        "notes": "Notes"
      }
    },
    "profiles": "Profiles",
    "profilesMenu": {
      "addProfile": "Add Profile...",
      "andy": "Andy",
      "benoit": "Benoit",
      "edit": "Edit...",
      "luis": "Luis"
    },
    "view": "View",
    "viewMenu": {
      "alwaysShowBookmarksBar": "Always Show Bookmarks Bar",
      "alwaysShowFullUrls": "Always Show Full URLs",
      "forceReload": "Force Reload",
      "hideSidebar": "Hide Sidebar",
      "reload": "Reload",
      "toggleFullscreen": "Toggle Fullscreen"
    }
  },
  "navigationMenu": {
    "backlog": "Backlog",
    "blocks": "Blocks",
    "blog": "Blog",
    "blogDescription": "Read our latest blog posts.",
    "components": "Components",
    "componentsDescription": "Browse all components in the library.",
    "documentation": "Documentation",
    "documentationDescription": "Learn how to use the library.",
    "done": "Done",
    "list": "List",
    "simpleList": "Simple List",
    "toDo": "To Do",
    "withIcons": "With Icons"
  },
  "orgName": "Mindsea Development",
  "otpInput": {
    "withCharacters": "With characters",
    "withDigits": "With digits",
    "withDigitsAndCharacters": "With digits and characters"
  },
  "progress": {
    "blurb": "A visual representation of the progress of a task or process.",
    "name": "Progress"
  },
  "radioGroup": {
    "cardLabel": "Card",
    "comfortable": "Comfortable",
    "compact": "Compact",
    "default": "Default",
    "disabledLabel": "Spacing (Disabled)",
    "planDescription": "Select a plan that works best for your team.",
    "planLabel": "Plan",
    "proDescription": "Advanced features larger teams looking to scale their business.",
    "proLabel": "Pro Plan",
    "spacingLabel": "Spacing",
    "starterDescription": "Perfect for small teams getting started with our platform.",
    "starterLabel": "Starter Plan"
  },
  "scrollArea": {
    "photoBy": "Photo by <bold>{{artist}}</bold>",
    "tags": "Tags"
  },
  "select": {
    "asyncMultiSelectLabel": "Multi select (async)",
    "asyncMultiSelectPlaceholder": "Select your favourite Pokemons",
    "asyncSingleSelectLabel": "Single select (async)",
    "asyncSingleSelectPlaceholder": "Select your favourite Pokemon",
    "disabled": "Disabled",
    "multiSelectLabel": "Multi select",
    "multiSelectPlaceholder": "Select colors",
    "singleSelectLabel": "Single select",
    "singleSelectPlaceholder": "Select a color"
  },
  "separator": {
    "blog": "Blog",
    "blurb": "Creates a visual or semantic distinction between content.",
    "description": "Vertical & horizontal seperators.",
    "docs": "Docs",
    "name": "Separator",
    "source": "Source",
    "title": "Separators"
  },
  "sheet": {
    "editProfile": {
      "description": "Make changes to your profile here. Click save when you're done.",
      "nameLabel": "Name",
      "title": "Edit profile",
      "usernameLabel": "Username"
    }
  },
  "skeleton": {
    "blurb": "A placeholder that represents the structure of a component while it is loading.",
    "name": "Skeleton"
  },
  "switch": {
    "airplaneMode": "Airplane mode",
    "bluetooth": "Bluetooth",
    "disabled": "Disabled switch",
    "required": "Required switch"
  },
  "table": {
    "caption": "A list of your recent invoices",
    "header": {
      "amount": "Amount",
      "invoice": "Invoice",
      "method": "Method",
      "status": "Status"
    },
    "total": "Total"
  },
  "tabs": {
    "account": "Account",
    "accountDescription": "Make changes to your account here. Click save when you're done.",
    "blurb": "A set of layered sections of content—known as tab panels—that are displayed one at a time.",
    "code": "Code",
    "currentPasswordLabel": "Current password",
    "disabled": "Disabled",
    "home": "Home",
    "name": "Tabs",
    "nameLabel": "Name",
    "newPasswordLabel": "New password",
    "password": "Password",
    "passwordDescription": "Change your password here. After saving, you'll be logged out.",
    "preview": "Preview",
    "savePasswordCta": "Save password",
    "settings": "Settings",
    "usernameLabel": "Username"
  },
  "text": {
    "blurb": "Design system typography",
    "copy": "The quick brown fox jumps over the lazy dog.",
    "name": "Text"
  },
  "textarea": {
    "default": "Default",
    "disabled": "Disabled",
    "error": "With error"
  },
  "theme": {
    "blurb": "Below is a list of all the colors in the current theme.\nToggle between light and dark mode to see how the colors adapt.",
    "name": "Theme",
    "paletteTitle": "Color Palette",
    "title": "Theme",
    "toggle": "Toggle Theme"
  },
  "title": "Component Sandbox",
  "toast": {
    "action": "Undo",
    "blurb": "A non-modal notification that appears temporarily to provide feedback to the user.",
    "default": "Event has been created",
    "description": "Monday, January 3rd at 6:00pm",
    "error": "Event could not be created",
    "info": "Be at the area 10 minutes before the event time",
    "name": "Toast",
    "warning": "Event start time cannot be earlier than 8am"
  },
  "tooltip": {
    "blurb": "A small pop-up that provides additional information about an element when hovered over or focused.",
    "content": "Add to library",
    "default": "Hover",
    "extendedContent": "To learn more about how this works, check out the docs.\n\nIf you have any questions, please reach out to us.",
    "info": "Info",
    "name": "Tooltip"
  }
}
